import React from "react";
import { Tab, Nav, Col,Row } from "react-bootstrap";
import { useAuth } from "../../contexts/authContext";
import { TabContainerProps, TabItemProps } from "./Types";
import { Translate } from '../Translate'

export const HorizontalTabs: React.FC<TabContainerProps> = ({ id, defaultActiveKey, tabs }) => {
    const { isAuthorizedFor, isAuthorizedForAttachmentType, isAuthorizedForItemType, isAuthorizedForPriceType, isAuthorizedForProjectType, isAuthorizedForWorkflowDefinition } = useAuth();

    const tabItems = tabs.map((tab) => {
        if (tab.visible !== false && isAuthorized(tab)) {
            return (
                <Nav.Item key={tab.title}>
                    <Nav.Link className='nav-item' eventKey={tab.eventKey}><Translate token={'#' + tab.eventKey}>{tab.title}</Translate></Nav.Link>
                </Nav.Item>
            );
        }
    });

    const tabPanes = tabs.map((tab) => {
        if (tab.visible !== false && isAuthorized(tab)) {
            return (
                <Tab.Pane eventKey={tab.eventKey} key={tab.title}>
                    {tab.component}
                </Tab.Pane>
            );
        }
    });

    function isAuthorized(tab: TabItemProps): boolean {
        if (tab.applicationFunction) {
            let isAuthorized = false;
            if (tab.attachmentTypeId !== undefined) {
                if (tab.attachmentTypeId === 0)
                    isAuthorized = isAuthorizedForAttachmentType(tab.applicationFunction);
                else
                    isAuthorized = isAuthorizedForAttachmentType(tab.applicationFunction, tab.attachmentTypeId);
            }

            else if (tab.itemTypeId !== undefined) {
                if (tab.itemTypeId === 0)
                    isAuthorized = isAuthorizedForItemType(tab.applicationFunction);
                else
                    isAuthorized = isAuthorizedForItemType(tab.applicationFunction, tab.itemTypeId);
            }

            else if (tab.projectTypeId !== undefined) {
                if (tab.projectTypeId === 0)
                    isAuthorized = isAuthorizedForProjectType(tab.applicationFunction);
                else
                    isAuthorized = isAuthorizedForProjectType(tab.applicationFunction, tab.projectTypeId);
            }

            else if (tab.priceTypeId !== undefined) {
                if (tab.priceTypeId === 0)
                    isAuthorized = isAuthorizedForPriceType(tab.applicationFunction);
                else
                    isAuthorized = isAuthorizedForPriceType(tab.applicationFunction, tab.priceTypeId);
            }

            else if (tab.workflowDefinitionId !== undefined) {
                if (tab.workflowDefinitionId === 0)
                    isAuthorized = isAuthorizedForWorkflowDefinition(tab.applicationFunction);
                else
                    isAuthorized = isAuthorizedForWorkflowDefinition(tab.applicationFunction, tab.workflowDefinitionId);

            }
            else
                isAuthorized = isAuthorizedFor(tab.applicationFunction);

            return isAuthorized;
        }
        else {
            //console.log(`Tab (${tab.title}): no authorizartion needed.`)
            return true;
        }
    }

    return (
        <Tab.Container id={id} defaultActiveKey={defaultActiveKey} mountOnEnter={true}>
            <Row className='tab-header-row'>
                <Col>
                    <Nav className="flex-row nav-tabs" style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                        {tabItems}
                    </Nav>
                </Col>
            </Row>
            <Row className='tab-content-row'>
                <Col>
                    <Tab.Content>
                        {tabPanes}
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    );
}